import React, { useState } from "react";
import styled, { css } from "styled-components";
import "./tablestyle.css";

import { Wrapper, NavText, NavTitle, TableContainer } from "./nav_components.js";
import { StyledBox } from "../../cards/card_componets.js";
import { BnameBadges } from "../solution/solution_components.js";
import { GraphTitle } from "./graph.js";

import { Reacttable } from "./table.js";

export default function AvgFee() {
  var bname = sessionStorage.getItem("bname");
  return (
    <Wrapper>
      <NavTitle> 내 주차장 주변 평균 주차요금</NavTitle>
      <NavText> 내 주차장 주변 주차장의 평균 주차요금입니다.</NavText>
      <StyledBox height="620" width="1200" padding="40">
        <GraphTitle fontSize="20" marginTop="20">
          <BnameBadges bname={bname}></BnameBadges>내 주차장 주변 주차장
          평균 주차 요금
        </GraphTitle>
          <TableContainer>
            <Reacttable />
          </TableContainer>
      </StyledBox>
    </Wrapper>
  );
}
